import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import { SvgIconName } from "components/components/Icon/Icon";
import React from "react";

import { QueueFilters } from "./QueueFilters/QueueFilters";
import {
  DeleteQueueButton,
  Label,
  QueueDetailsRow,
  QueueInfoContainer,
  QueueInfoContent,
  QueueInfoHeader,
  QueueInfoHeaderInner,
  QueueInfoHeaderTitle,
  Value,
} from "./style";

type QueueInfoProps = {
  queueName: string;
  queueUrl: string;
  queueTitle: string;
  filters: string[];
  onDeleteClick: () => void;
  onRemoveAllFiltersClick: () => void;
  fetchIrisDetails: () => void;
};

type PairProps = {
  label: string;
  value: string;
};

const LabelValuePairWithCopyButton: React.FC<PairProps> = ({
  label,
  value,
}) => {
  const id = React.useId();
  const labelId = `label-${id}`;
  const valueId = `value-${id}`;

  return (
    <QueueDetailsRow>
      <Label id={labelId}>{label}</Label>
      <Value id={valueId} aria-labelledby={labelId}>
        {value}
      </Value>
      <CopyToClipboard value={value} label={label} />
    </QueueDetailsRow>
  );
};

const QueueInfo: React.FC<QueueInfoProps> = ({
  queueName,
  queueUrl,
  queueTitle,
  filters,
  onDeleteClick,
  onRemoveAllFiltersClick,
  fetchIrisDetails,
}) => (
  <QueueInfoContainer>
    <QueueInfoHeader>
      <QueueInfoHeaderInner>
        <QueueInfoHeaderTitle>{queueTitle}</QueueInfoHeaderTitle>
        <DeleteQueueButton
          ariaLabel={`Delete queue ${queueTitle}`}
          buttonText="Delete"
          iconName={SvgIconName.Delete}
          onClick={onDeleteClick}
          textLeftOfIcon
        />
      </QueueInfoHeaderInner>
    </QueueInfoHeader>
    <QueueInfoContent>
      <LabelValuePairWithCopyButton label="Queue name" value={queueName} />
      <LabelValuePairWithCopyButton label="Queue URL" value={queueUrl} />
      <br />
      <QueueFilters
        queueTitle={queueTitle}
        appliedFilters={filters}
        onRemoveAllFiltersClick={onRemoveAllFiltersClick}
        fetchIrisDetails={fetchIrisDetails}
      />
    </QueueInfoContent>
  </QueueInfoContainer>
);

export default QueueInfo;
